<template>
  <div class="profile">
    <v-card class="user-header" :height="$vuetify.breakpoint.xs ? 250 : 350">
      <v-btn small fab class="wallpaper-edit" @click="$refs.wallpaper.click()">
        <input 
          type="file" 
          ref="wallpaper" 
          :accept="$accept_file_type.image"
          onclick="this.value = null" 
          @change="upload('wallpaper')"
        >
        <v-icon small icon>fa-edit</v-icon>
      </v-btn>
      <v-img
        class="white--text align-end wallpaper"
        height="100%"
        gradient="to top, rgba(0, 0, 0, .5), rgba(0, 0, 0, 0)"
        :src="user.wallpaper ? $HOST_URL + user.wallpaper : ''"
      >
        <v-card-title class="flex-nowrap">
          <v-avatar size="80" class="mr-3 user-icon">
            <button @click="$refs.icon.click()">修改</button>
            <input 
              type="file" 
              ref="icon" 
              :accept="$accept_file_type.image"
              onclick="this.value = null" 
              @change="upload('usericon')"
            >
            <v-img :src="$HOST_URL + user.usericon"/>
          </v-avatar>
          <div class="overflow-hidden flex-grow-1">
            <div class="d-flex">
              <v-text-field
                v-model="nickname"
                v-if="editing_nickname"
                outlined
                color="white"
                dense
                solo
                autofocus
                @keydown.enter="edit_nickname"
              ></v-text-field>
              <span v-if="!editing_nickname" class="text-ellipsis">{{ user.nickname }}</span>
              <v-btn small fab class="ml-2 nickname-edit" @click="editing_nickname = true" v-if="!editing_nickname">
                <v-icon small>fa-edit</v-icon>
              </v-btn>
              <v-btn dark small fab class="ml-2 green nickname-edit" @click="edit_nickname" v-if="editing_nickname">
                <v-icon small>fa-check</v-icon>
              </v-btn>
            </div>
            <!-- <div class="caption my-1 d-flex align-center">
              VIP等級: 
              <v-icon small class="mx-3">fa-gem</v-icon>
              <v-progress-linear
                value="40"
                color="white"
                style="width: 100px"
                class="mr-3"
              ></v-progress-linear>
              40 / 100
            </div> -->
            <!-- <div class="caption my-1">
              經驗值: <span class="font-weight-bold">{{ user.point }}</span>
            </div> -->
            <div class="d-flex align-center">
              <div class="mr-2">
                <div class="peach mr-2"></div>
                <span :class="['pink--text', {'body-1': $vuetify.breakpoint.xsOnly}]">{{ user.peach }}</span>
              </div>
              <v-spacer></v-spacer>
              <div class="other-info">
                <div>{{ user.followers　}}</div>
                <div>粉絲</div>
              </div>
              <div class="other-info">
                <div>{{ user.follows　}}</div>
                <div>追蹤中</div>
              </div>
            </div>
          </div>
        </v-card-title>
      </v-img>
    </v-card>
    <div class="user-body">
      <div class="px-3 my-4 font-weight-bold">商品</div>
      <v-btn block to="/purchase">購買清單</v-btn>
      <v-btn block to="/unlocks">解鎖項目</v-btn>
      <v-btn block @click="$root.$emit('peachList')">購買桃子</v-btn>

      <div class="px-3 my-4 font-weight-bold">隠私</div>
      <v-btn block to="/blocks">封鎖主播</v-btn>

      <div class="px-3 my-4 font-weight-bold">設定</div>
      <v-btn block @click="sendVerifyMail">
        <div>Email</div>
        <div>
          <!-- <span v-if="sending" class="pr-2">({{ time }})</span> -->
          <span>{{ user.email }}</span>
          <span v-if="!user.email_verified" class="red--text"> (未驗證) </span>
          <span v-else class="green--text"> (已驗證) </span>
        </div>
      </v-btn>
      <v-btn block @click="user.tel_verified ? '' : $refs.verifyTel.dialog = true">
        <div>手機號碼</div>
        <div>
          <span>{{ user.tel }}</span>
          <span v-if="!user.tel_verified" class="red--text"> (未驗證) </span>
          <span v-else class="green--text"> (已驗證) </span>
        </div>
      </v-btn>
      <v-btn block @click="$root.$emit('authentication')">
        <div>身份驗證</div>
        <div>
          <span v-if="!user.identity_verified" class="red--text"> (未驗證) </span>
          <span v-else class="green--text"> (已驗證) </span>
        </div>
      </v-btn>
      <v-btn block @click="$refs.changePassword.open('member')">重置密碼</v-btn>

      <div class="px-3 my-4 font-weight-bold">關於</div>
      <v-btn block>
        <div>語言</div>
        <span>繁體中文</span>
      </v-btn>
      <v-btn block @click="$refs.aboutus.dialog = true">聯繫客服</v-btn>
      <v-btn block to="/policy">隱私權政策</v-btn>
      <v-btn block to="/terms">服務條款</v-btn>
    </div>

    <div class="pa-6 mt-4">
      <v-btn dark block color="red" @click="logout">登出</v-btn>
    </div>
    <ChangePassword ref="changePassword"></ChangePassword>
    <VerifyTel ref="verifyTel" :tel="user.tel"></VerifyTel>
    <AboutUs ref="aboutus"></AboutUs>
    <EmailSent ref="emailSent" :sending="sending" :time="time" @reSend="sendVerifyMail"></EmailSent>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ChangePassword from '@/components/ChangePassword'
import VerifyTel from '@/components/VerifyTel'
import AboutUs from '@/components/AboutUs'
import EmailSent from '@/components/EmailSent'
export default {
  components: { ChangePassword, VerifyTel, AboutUs, EmailSent },
  created() {
      document.title = `${this.user.nickname} 的個人資料 - ${this.$TITLE}`
  },
  data() {
    return {
      editing_nickname: false,
      nickname: '',
      sending: false,
      time: this.$resendTime
    }
  },
  computed: {
    ...mapState('user', ['user'])
  },
  methods: {
    async upload(target) {
      let file = event.target.files[0]
      if(!await this.$func.fileValidation(file)) {
        return
      }
      let url = (target == 'wallpaper') ? '/member/wallpaper' : '/member/icon'
      let data = {}
      data[target] = await this.$func.fileToBase64(file)
      this.axios.put(url, data).then(response => {
        this.$store.dispatch('user/getUserInformation', target)
        this.$root.$emit('alert', 'success', '修改成功')

      }).catch(() => {
        this.$root.$emit('alert', 'error', '修改失敗')
      })
    },
    logout() {
      this.axios.post('/member/logout').then(response => {
        this.$store.dispatch('user/logout')
        this.$store.dispatch('shoppingCart/reset')
        this.$router.push('/login')
      })
    },
    edit_nickname() {
      if(this.nickname == '') {
        this.editing_nickname = false
        return
      }
      this.axios.put('/member/nickname', {
        nickname: this.nickname
      }).then(response => {
        this.$store.dispatch('user/setNickname', this.nickname)
        this.$root.$emit('alert', 'success', '修改成功')
      }).finally(() => {
        this.nickname = ''
        this.editing_nickname = false
      })
    },
    sendVerifyMail() {
      if(this.user.email_verified) {
        return
      }
      this.$store.dispatch('user/sendVerifyMail').then(response => {
        this.$refs.emailSent.dialog = true
        this.$root.$emit('alert', 'success', '發送成功')
        this.startTimer()
      }).catch(e => {
        if(e.response) {
          let minute = e.response.data.message.match(/Try again after (\d+) minute/)
          if(minute) {
            this.$root.$emit('alert', 'error', `請${minute[minute.length - 1]}分鐘後再試`)
          }
          else if(e.response.data.message.includes('Please contact our customer service')) {
            this.$root.$emit('alert', 'error', '發送次數過多，請聯繫我們')
          }
        }
        else {
          this.$root.$emit('alert', 'error', '發送失敗')
        }
      })
    },
    startTimer() {
      this.sending = true
      var timer = setInterval(() => {
        this.time -= 1 
        if(this.time < 0) {
          this.time = this.$resendTime
          clearInterval(timer)
          this.sending = false
        }
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
.profile {
  padding-bottom: 50px;
  .user-header {
    position: relative;
    .nickname-edit {
      width: 30px;
      height: 30px;
    }
    .wallpaper-edit {
      position: absolute;
      right: 15px;
      top: 15px;
      z-index: 1;
    }
    .user-icon {
      button {
        position: absolute;
        bottom: -14px;
        background-color: rgba(0, 0, 0, .7);
        width: 100%;
        height: 30px;
        padding-bottom: 15px;
        font-size: 12px;
        font-weight: 300;
        z-index: 1;
      }
    }
    .v-input__control {
      min-height: 0 !important;
      .v-input__slot {
        min-height: 30px !important;
      }
    }
    .v-text-field__details {
      display: none;
    }
    .other-info {
      display: flex;
      flex-direction: column;
      margin: 0 20px;
      font-size: 14px;
      align-items: center;
      line-height: 24px;
      @include mobile {
        margin: 0 6px;
      }
      div {
        white-space: nowrap;
      }
    }
  }
  .user-body {
    .v-btn {
      text-transform: none;
      color: white;
      font-weight: 200;
      background-color: $grey-2 !important;
      border-bottom: 1px solid grey;
      border-top: 1px solid grey;
      .v-btn__content {
        display: flex;
        justify-content: space-between;
        span {
          color: lightgrey;
        }
      }
    }
  }
}
</style>